"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pick = void 0;
/**
 * Pick object by key
 *
 * @param object
 * @param keys
 * @returns {*}
 */
var pick = function pick(object, keys) {
  return keys.reduce(function (obj, key) {
    if (object && object.hasOwnProperty(key)) {
      obj[key] = object[key];
    }
    return obj;
  }, {});
};
exports.pick = pick;